// document.addEventListener('DOMContentLoaded', function () {
//     if (window.innerWidth < 1025) {
//         var swiper = new Swiper(".block__albee-points-info", {
//             slidesPerView: 6,
//             spaceBetween: 20,
//             pagination: {
//                 el: ".swiper-pagination",
//                 type: "progressbar",
//             },
//             autoplay: {
//                 delay: 1000,
//                 disableOnInteraction: false
//             },
//             breakpoints: {
//                 280: {
//                     slidesPerView: 2,
//                     spaceBetween: 20,
//                 },
//                 425: {
//                     slidesPerView: 2,
//                     spaceBetween: 20,
//                 },
//                 749: {
//                     slidesPerView: 3,
//                     spaceBetween: 20,
//                 },
//                 991: {
//                     slidesPerView: 4,
//                     spaceBetween: 20,
//                 }
//             },
//         });
//     }
// });

document.addEventListener('DOMContentLoaded', function() {
    function initializeSwiper() {
        var swiperContainer = document.querySelector('.block__albee-points-info');

        // Check if the Swiper container exists
        if (!swiperContainer) return;

        // Check the screen width and initialize Swiper
        if (window.innerWidth < 1025) {
            if (!swiperContainer.classList.contains('swiper-initialized')) {
                var swiper = new Swiper(".block__albee-points-info", {
                    slidesPerView: 6,
                    spaceBetween: 20,
                    pagination: {
                        el: ".swiper-pagination",
                        type: "progressbar",
                    },
                    autoplay: {
                        delay: 1000,
                        disableOnInteraction: false
                    },
                    mousewheel: {
                        forceToAxis: true,
                    },
                    breakpoints: {
                        280: {
                            slidesPerView: 2,
                            spaceBetween: 20,
                        },
                        425: {
                            slidesPerView: 2,
                            spaceBetween: 20,
                        },
                        749: {
                            slidesPerView: 3,
                            spaceBetween: 20,
                        },
                        991: {
                            slidesPerView: 4,
                            spaceBetween: 20,
                        }
                    },
                });
                swiperContainer.classList.add('swiper-initialized'); // Mark as initialized
            }
        } else {
            if (swiperContainer.classList.contains('swiper-initialized')) {
                // Destroy Swiper if it's already initialized
                swiper.destroy(true, true);
                swiperContainer.classList.remove('swiper-initialized'); // Clean up
            }
        }
    }

    initializeSwiper();
    window.addEventListener('resize', initializeSwiper);
});
